// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-status-field[data-v-5010e930]{padding:0 var(--spacer) 0 var(--spacer-sm);text-transform:uppercase;font-size:10px;line-height:12px;letter-spacing:1px;font-weight:var(--font-weight-medium);position:relative}.dashboard-status-field[data-v-5010e930]{background-color:var(--highlight);color:var(--solid)}.dashboard-status-field[data-v-5010e930] .v-icon{margin-right:var(--spacer-xxs);width:16px;height:16px;color:var(--solid)}", ""]);
// Exports
module.exports = exports;
